// extracted by mini-css-extract-plugin
module.exports = {"link":"BatchDeliveryTable_link__2b4Xa"};